import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BuddibleSocket, { MsgIDList } from "../../../../lib/BuddibleSocket";
import CodeList from "../../../../lib/CodeList";
import Utilities from "../../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "ScheduleAirFreightCostModal";

const FSC_COST = {
  S: { type: "C/WT", minAmount: 0, cost: 570 },
  M: { type: "C/WT", minAmount: 0, cost: 600 },
  L: { type: "C/WT", minAmount: 0, cost: 640 },
};

const SCC_COST = {
  ID: { type: "C/WT", minAmount: 6500, cost: 130 },
  DE: { type: "C/WT", minAmount: 6500, cost: 130 },
  US: { type: "C/WT", minAmount: 6500, cost: 130 },
};

let costData = null;
let today = new Date();

export default function ScheduleAirFreightCostModal({
  loginInfo,
  modal_data = {},
  handleCostModalOpen,
}) {
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const isBooking = +today < +modal_data.subData.realDate;
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    requestUserSelect();
    return () => {
      costData = null;
    };
  }, []);

  function requestUserSelect() {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/schedule_air/JS_schedule_price_air_select.php",
      msgID: msgID,
      data: {},
      sm_POL_CODE: modal_data.mainData.sm_POL_CODE,
      sm_POD_CODE: modal_data.mainData.sm_POD_CODE,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          costData = {
            sm_IDX: modal_data.mainData.sm_IDX,
            sm_FWD_NO: modal_data.mainData.sm_FWD_NO,
            sm_FWD_NM: modal_data.mainData.sm_FWD_NM,
            sm_PROVIDER_CODE: modal_data.mainData.sm_PROVIDER_CODE,
            sm_PROVIDER_ID: modal_data.mainData.sm_PROVIDER_ID,
            sm_PROVIDER_SALES_ID: modal_data.mainData.sm_PROVIDER_SALES_ID,
            sm_DEPARTURE_DATE: modal_data.mainData.sm_DEPARTURE_DATE,
            sm_VESSEL: modal_data.mainData.sm_VESSEL,
            sm_CARGO_YN: modal_data.mainData.sm_CARGO_YN,
            sm_POL_CODE: modal_data.mainData.sm_POL_CODE,
            sm_POD_CODE: modal_data.mainData.sm_POD_CODE,
            sm_ORIGIN: modal_data.mainData.sm_ORIGIN,
            sm_DEST: modal_data.mainData.sm_DEST,
            sm_EXP_IMP: modal_data.mainData.sm_EXP_IMP,
            ...modal_data.subData,
            ...newData["returnData"][0],
          };
          setIsNeedUpdate(!isNeedUpdate);
        }
      }
    });
  }

  function moveToReserveAIR() {
    if (!loginInfo) {
      codeList.Modal.current.alert(t("schedule.msg.requiresLogin"));
      return;
    }
    if (!(loginInfo.COMP_GB !== "B" || loginInfo.COMP_GB !== "Z")) {
      codeList.Modal.current.alert(t("schedule.msg.onlyForwarder"));
      return;
    }

    socket.sendLocalMessage(
      MsgIDList.EVENT_MOVE_RESERVE_AIR,
      _mClassName,
      costData,
      () => {}
    );
    navigate(`/ReserveAIR/${costData.sm_IDX}`);
  }

  return (
    <div className="modal_background">
      <div className="modal_body bg-white rounded" style={{ minWidth: 320 }}>
        <div className="container-fluid m-0 p-0">
          <div className="row m-0 p-3 border-bottom">
            <div className="col-10 m-0 p-0">
              <p className="h6 font-weight-bold mr-3 p-0 m-0">
                {t("schedule.air.costModal.title")}
              </p>
            </div>
            <div className="col-2 m-0 p-0 text-right">
              <div
                className="h5 mb-0 text-danger cursor_pointer font-weight-bold"
                onClick={() => handleCostModalOpen()}
              >
                &times;
              </div>
            </div>
          </div>
          <div
            className="overflow-auto p-3 px-3"
            style={{ maxHeight: "calc(100vh - 200px)" }}
          >
            {costData !== null && (
              <>
                <div className="row m-0 p-0">
                  <div className="col-12 m-0 mb-1 p-0">
                    <p className="font-weight-bold">
                      ※ {t("schedule.air.costModal.scheduleInfoSummary")}
                    </p>
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <div className="d-flex flex-column flex-xl-row flex-wrap border rounded-top-left rounded-top-right overflow-hidden">
                      <div className="flex-grow-1 d-flex flex-column flex-md-row">
                        <div className="border-top border-right flex-grow-1">
                          <div
                            className="px-2 py-1 bg-info text-white font-weight-bold text-center border-bottom"
                            style={{ minWidth: 100 }}
                          >
                            {t("schedule.air.airline")}
                          </div>
                          <div
                            className="d-flex flex-row justify-content-center align-items-center"
                            style={{ height: 55 }}
                          >
                            <div
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{
                                minHeight: 30,
                                width: 80,
                                background: `url(${modal_data.mainData.AL_LOGO}) 50% 50% / contain no-repeat`,
                              }}
                            >
                              {!modal_data.mainData.AL_LOGO && (
                                <span>LOGO</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="border-top border-right flex-grow-1">
                          <div
                            className="px-2 py-1 bg-info text-white font-weight-bold text-center border-bottom"
                            style={{ minWidth: 100 }}
                          >
                            {t("schedule.air.supplier")}
                          </div>
                          <div
                            className="d-flex flex-row justify-content-center align-items-center"
                            style={{ height: 55 }}
                          >
                            <div
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{
                                minHeight: 30,
                                width: 80,
                                background: `url(${modal_data.mainData.SL_LOGO}) 50% 50% / contain no-repeat`,
                              }}
                            >
                              {!modal_data.mainData.SL_LOGO && (
                                <span>LOGO</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="border-top border-right flex-grow-1">
                          <div
                            className="px-2 py-1 bg-info text-white font-weight-bold text-center border-bottom"
                            style={{ minWidth: 100 }}
                          >
                            {t("schedule.air.costModal.flight")}
                          </div>
                          <div
                            className="d-flex flex-column justify-content-center align-items-center"
                            style={{ height: 55 }}
                          >
                            <p>{costData.FLIGHT_NAME}</p>
                            <p>{costData.AIR_FREIGHT_NO}</p>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 d-flex flex-column flex-md-row">
                        <div className="border-top border-right flex-grow-1">
                          <div
                            className="px-2 py-1 bg-info text-white font-weight-bold text-center border-bottom"
                            style={{ minWidth: 100 }}
                          >
                            {t("schedule.air.costModal.departure")}
                          </div>
                          <div
                            className="d-flex flex-column justify-content-center align-items-center"
                            style={{ height: 55 }}
                          >
                            <p className="font-weight-bold">
                              {costData.sm_ORIGIN}
                            </p>
                            <p className="font-weight-bold text-danger">
                              {costData.sm_POL_CODE} {costData.DEPARTURE_TIME}
                            </p>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div
                            className="px-2 py-1 bg-info text-white font-weight-bold text-center border-bottom"
                            style={{ minWidth: 100 }}
                          >
                            {t("schedule.air.costModal.arrival")}
                          </div>
                          <div
                            className="d-flex flex-column justify-content-center align-items-center"
                            style={{ height: 55 }}
                          >
                            <p className="font-weight-bold">
                              {costData.sm_DEST}
                            </p>
                            <p className="font-weight-bold text-danger">
                              {costData.sm_POD_CODE} {costData.AIRRIVE_TIME}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row m-0">
                  <div className="col-12 m-0 mb-1 p-0">
                    <p className="font-weight-bold">
                      ※ {t("schedule.air.costModal.costInfo")}
                    </p>
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <div className="d-flex flex-column flex-sm-row flex-wrap border-bottom border-left rounded overflow-hidden">
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          {t("schedule.air.costModal.type")}
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_TYPE || "-"}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          {t("schedule.air.costModal.currency")}
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_MONEY_KIND || "-"}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          {t("schedule.air.costModal.minCost")}
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_MIN
                            ? util.addCommas(costData.SPA_COST_MIN)
                            : "-"}{" "}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          - 45K
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_MINUS_45K
                            ? util.addCommas(costData.SPA_COST_MINUS_45K)
                            : "-"}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          + 45K
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_PLUS_45K
                            ? util.addCommas(costData.SPA_COST_PLUS_45K)
                            : "-"}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          + 100K
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_100K
                            ? util.addCommas(costData.SPA_COST_100K)
                            : "-"}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          + 300K
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_300K
                            ? util.addCommas(costData.SPA_COST_300K)
                            : "-"}{" "}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          + 500K
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_500K
                            ? util.addCommas(costData.SPA_COST_500K)
                            : "-"}
                        </div>
                      </div>
                      <div className="border-top border-right flex-grow-1">
                        <div className="px-2 py-1 bg-light font-weight-bold text-center border-bottom">
                          + 1000K
                        </div>
                        <div className="px-2 py-1 d-flex flex-row justify-content-center align-items-center">
                          {costData.SPA_COST_1000K
                            ? util.addCommas(costData.SPA_COST_1000K)
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row m-0 p-0">
                  <div className="col-12 m-0 p-0">
                    <p className="font-weight-bold">
                      ※ {t("schedule.air.costModal.etcCostInfo")}
                    </p>
                  </div>
                  <div className="col-12 m-0 mb-2 p-0 border">
                    <div className="row m-0 p-0 text-center bg-light font-weight-bold">
                      <div className="col-2 m-0 px-2 py-1 border-bottom border-right">
                        {t("schedule.air.costModal.freight")}
                      </div>
                      <div className="col-4 m-0 px-2 py-1 border-bottom border-right">
                        {t("schedule.air.costModal.freightName")}
                      </div>
                      <div className="col-2 m-0 px-2 py-1 border-bottom border-right">
                        {t("schedule.air.costModal.type")}
                      </div>
                      <div className="col-2 m-0 px-2 py-1 border-bottom border-right">
                        Min Amount
                      </div>
                      <div className="col-2 m-0 px-2 py-1 border-bottom">
                        {t("schedule.air.costModal.cost")}
                      </div>
                    </div>
                    <div className="row m-0 p-0 text-center">
                      <div className="col-2 m-0 px-2 py-1 bg-light border-bottom border-right">
                        CGC
                      </div>
                      <div className="col-4 m-0 px-2 py-1 bg-light border-bottom border-right">
                        CGC CHARGE
                      </div>
                      <div className="col-2 m-0 px-2 py-1 border-bottom text-right border-right">
                        B/L
                      </div>
                      <div className="col-2 m-0 px-2 py-1 border-bottom text-right border-right">
                        0
                      </div>
                      <div className="col-2 m-0 px-2 py-1 border-bottom text-right">
                        3,000
                      </div>
                    </div>
                    <div className="row m-0 p-0 text-center">
                      <div className="col-2 m-0 px-2 py-1 bg-light border-right">
                        FSC
                      </div>
                      <div className="col-4 m-0 px-2 py-1 bg-light border-right">
                        FUEL SURCHARGE
                      </div>

                      <div className="col-2 m-0 px-2 py-1 text-right border-right">
                        {costData.SPA_DISTANCE
                          ? FSC_COST[costData.SPA_DISTANCE].type
                          : "-"}
                      </div>
                      <div className="col-2 m-0 px-2 py-1 text-right border-right">
                        {costData.SPA_DISTANCE
                          ? util.addCommas(
                              FSC_COST[costData.SPA_DISTANCE].minAmount
                            )
                          : "-"}
                      </div>
                      <div className="col-2 m-0 px-2 py-1 text-right">
                        {costData.SPA_DISTANCE
                          ? util.addCommas(FSC_COST[costData.SPA_DISTANCE].cost)
                          : "-"}
                      </div>
                    </div>
                    {SCC_COST.hasOwnProperty(costData.SPA_COUNTRY) && (
                      <div className="row m-0 p-0 border-top text-center">
                        <div className="col-2 m-0 px-2 py-1 bg-light border-right">
                          SCC
                        </div>
                        <div className="col-4 m-0 px-2 py-1 bg-light border-right">
                          SECURITY CHARGE
                        </div>
                        <div className="col-2 m-0 px-2 py-1 text-right border-right">
                          {SCC_COST[costData.SPA_COUNTRY].type}
                        </div>
                        <div className="col-2 m-0 px-2 py-1 text-right border-right">
                          {util.addCommas(
                            SCC_COST[costData.SPA_COUNTRY].minAmount
                          )}
                        </div>
                        <div className="col-2 m-0 px-2 py-1 text-right">
                          {util.addCommas(SCC_COST[costData.SPA_COUNTRY].cost)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row m-0 p-0 mb-2">
                  <div className="col-auto flex-fill m-0 p-0">
                    <p className="font-weight-bold">
                      · {t("schedule.air.costModal.bookingManagerInfo")}
                    </p>
                    <p className="text-secondary ml-2 mb-2">
                      김호승 본부장(<a href="tel:032-751-9870">032-751-9870</a>,{" "}
                      <a href="mailto:hskim@bstc.kr">hskim@bstc.kr</a>)
                    </p>
                    <p className="font-weight-bold">
                      · {t("schedule.air.costModal.supplierManagerInfo")}
                    </p>

                    {modal_data.mainData.sm_PROVIDER_CODE === "B0036" ? (
                      <p className="text-secondary ml-2">
                        김미경 과장(
                        <a href="mailto:scl@sclogistics.co.kr">
                          scl@sclogistics.co.kr
                        </a>
                        )
                      </p>
                    ) : (
                      <p className="text-secondary ml-2 mb-2">
                        김호승 본부장(
                        <a href="tel:032-751-9870">032-751-9870</a>,{" "}
                        <a href="mailto:hskim@bstc.kr">hskim@bstc.kr</a>)
                      </p>
                    )}
                  </div>
                  <div className="col-auto m-0 p-0">
                    <p className="font-weight-bold">
                      · {t("schedule.air.costModal.bookYN")} :{" "}
                      <span
                        className={isBooking ? "text-primary" : "text-danger"}
                      >
                        {isBooking
                          ? t("schedule.air.costModal.available")
                          : t("schedule.air.costModal.unavailable")}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="row m-0 p-0">
                  <div className="col-auto flex-fill m-0 p-0">
                    <p className="font-weight-bold">
                      · {t("schedule.air.costModal.cargoReceiveLocationInfo")}
                    </p>
                    {modal_data.mainData.sm_FWD_NO === "ASIANA" ? (
                      <>
                        <p className="text-secondary ml-2">(주)더블유코리아</p>
                        <p className="text-secondary ml-2">
                          인천시 중구 공항동로 296번길 98-30 범한판토스 내 27-28
                          GATE
                        </p>
                        <p className="text-secondary ml-2">032-744-7404</p>
                      </>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>

                <div className="row m-0 p-0">
                  <div className="col-12 m-0 mb-2 p-0 text-right">
                    <button
                      disabled={!isBooking}
                      onClick={() => {
                        moveToReserveAIR();
                      }}
                      className="btn btn-sm btn-primary"
                    >
                      {t("schedule.air.costModal.booking")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
